var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 403.48 403.48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M277.271,0H46.176v403.48h311.129V80.035L277.271,0z M281.664,25.607l50.033,50.034h-50.033V25.607z M61.176,388.48V15 h205.489v75.641h75.641v297.84H61.176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.439,117.58h55.18V62.4h-55.18V117.58z M116.439,77.4h25.18v25.18h-25.18V77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.439,192.08h55.18V136.9h-55.18V192.08z M116.439,151.9h25.18v25.18h-25.18V151.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.439,266.581h55.18V211.4h-55.18V266.581z M116.439,226.4h25.18v25.181h-25.18V226.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.439,341.081h55.18v-55.18h-55.18V341.081z M116.439,300.901h25.18v25.18h-25.18V300.901z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.835,
    y: 326.081,
    width: 114.688,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.835,
    y: 251.581,
    width: 114.688,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.835,
    y: 177.08,
    width: 114.688,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.835,
    y: 102.58,
    width: 114.688,
    height: 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.0e0e85c967c17ddaab8e40da8fc6d8a9.svg";
export { ForwardRef as ReactComponent };